'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdScreenRotation = function MdScreenRotation(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm12.5 35.8l2.3-2.2 6.3 6.3-1.1 0.1c-10.5 0-19.1-8.1-19.9-18.4h2.5c0.6 6.3 4.4 11.6 9.9 14.2z m12.2-0.5l10.6-10.6-20-20-10.6 10.6z m-7.7-32.4l20.1 20.1c1 0.9 1 2.5 0 3.5l-10.6 10.6c-1 1-2.5 1-3.5 0l-20.1-20.1c-1-0.9-1-2.5 0-3.5l10.6-10.6c1-1 2.5-1 3.5 0z m10.5 1.3l-2.3 2.2-6.3-6.3 1.1-0.1c10.5 0 19.1 8.1 19.9 18.4h-2.5c-0.6-6.3-4.4-11.6-9.9-14.2z' })
        )
    );
};

exports.default = MdScreenRotation;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/screen-rotation.js
// module id = 3262
// module chunks = 0